import React from "react";
import { useDispatch } from "react-redux";
import "./noBearing.scss";
import { Box, makeStyles } from "@material-ui/core";
import Button from "../Button";
import { registerInsurancePolicy } from "../../redux/insurancePoliciesCar";

const useStyles = makeStyles((theme) => ({
  container: {
    borderTop: "2px solid #cfdae2",
    position: "relative",
    marginTop: 8,
    marginBottom: 16,
    [theme.breakpoints.up("md")]: {
      marginBottom: 0,
      marginTop: 30,
    },
  },
  title: {
    fontSize: "16px",
    color: "#004987",
    margin: "-20px",
    padding: "0 10px",
    marginBottom: "5%",
    backgroundColor: "#fff",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
    },
  },
  imgContainer: {
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    flexWrap: "wrap",
  },
}));

export default function NoBearing(props) {
  const dispatch = useDispatch();
  const classes = useStyles();

  function handleClick() {
    props.closeModal(false);
    dispatch(registerInsurancePolicy());
  }
  return (
    <>
      <Box classes={{ root: classes.container }}>
        <Box display='flex' justifyContent='center' mt='8px'>
          <Box
            classes={{ root: classes.title }}
            component='h3'
            fontWeight='fontWeightBold'
          >
            Consideración <b>IMPORTANTE</b>{" "}
          </Box>
        </Box>
      </Box>
      <div className='declaration-container'>
        Debés enviar el certificado de no rodamiento a
        clientes.patagonia@segurossura.com.ar dentro de los 10 días corridos.
      </div>

      <div className='button-container'>
        <Button color='primary' onClick={() => props.closeModal(false)}>
          Volver
        </Button>
        <Button color='secondary' onClick={() => handleClick()}>
          Continuar
        </Button>
      </div>
    </>
  );
}
